import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Button } from '../Button/Button.js';

function EmptyState(props) {
  var _a, _b, _c, _d;
  const {
    icon,
    title,
    description
  } = props;
  const titleProps = (_a = props.titleProps) !== null && _a !== void 0 ? _a : {};
  const descriptionProps = (_b = props.descriptionProps) !== null && _b !== void 0 ? _b : {};
  const wrapperProps = (_c = props.wrapperProps) !== null && _c !== void 0 ? _c : {};
  const buttonProps = (_d = props.buttonProps) !== null && _d !== void 0 ? _d : {};
  const wrapperClassName = clsx('flex flex-column align-items-center p-4 gap-2', wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.className);
  const titleClassName = clsx(wrapperProps.className, titleProps.className);
  const descriptionClassName = clsx('text-center', descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.className);
  const buttonClassName = clsx('mt-2', buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className);
  return jsxs("div", Object.assign({}, wrapperProps, {
    className: wrapperClassName,
    children: [icon, title || props.titleProps ? jsx("h2", Object.assign({}, titleProps, {
      className: titleClassName,
      children: title ? title : titleProps.content
    })) : null, description || props.descriptionProps ? jsx("p", Object.assign({}, descriptionProps, {
      className: descriptionClassName,
      children: description ? description : descriptionProps.content
    })) : null, props.buttonProps ? jsx(Button, Object.assign({}, buttonProps, {
      className: buttonClassName
    })) : null]
  }));
}

export { EmptyState };
